import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportAProblemPageComponent } from '../report-a-problem-page/report-a-problem-page.component';

@Component({
  selector: 'app-otx-report',
  templateUrl: './otx-report.component.html',
  styleUrls: ['./otx-report.component.scss']
})
export class OTXReportComponent implements OnInit {

  constructor( private modalService: NgbModal) { }

  ngOnInit(): void {
    if (1 == 1) {
      const modalRef = this.modalService.open(ReportAProblemPageComponent, {
        windowClass: "myCustomModalClass",
        backdrop: 'static'
      });
      modalRef.result.then(
        result => {
          console.log(result);
        },
        reason => { }
      );

    }
  }

}
